export default __webpack_public_path__ + "static/media/hydraulic_data_curved.cc8fb5b8.png";